<template>
  <div>
    <div
      v-if="Object.keys(pixel).length === 0"
      class="d-flex justify-content-center mb-1"
    >
      <b-spinner label="Loading..." />
    </div>
    <div v-else>
      <breadcrumbs
        :breadcrumb-items="breadcrumbItems"
      />
      <UserToolbar
        v-if="authUserData.user_id !== $route.params.userId"
        :account="account"
      />
      <b-form @submit.prevent>
        <validation-observer ref="validationPixelRules">
          <b-tabs
            pills
          >
            <b-tab active>
              <!-- title -->
              <template #title>
                <feather-icon
                  icon="SettingsIcon"
                  size="18"
                  class="mr-50"
                />
                <span class="font-weight-bold">{{ $t('Settings') }}</span>
              </template>
              <b-card>
                <div class="head-card">
                  <div class="head-card-top">
                    <h4>{{ $t('pixels.edit') }}</h4>
                    <feather-icon
                      v-b-tooltip.hover.top="$t('Close')"
                      icon="XIcon"
                      size="18"
                      class="toggle-close cursor-pointer"
                      @click="$router.go(-1)"
                    />
                  </div>
                  <hr>
                </div>
                <b-row>
                  <b-col md="6">
                    <b-form-group
                      :label="$t('pixels.title')"
                      label-for="i-name"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="name"
                        rules="required"
                      >
                        <b-input-group
                          class="input-group-merge"
                          :class="errors.length == 0 || 'is-invalid'"
                        >
                          <b-input-group-prepend is-text>
                            <feather-icon icon="LayoutIcon" />
                          </b-input-group-prepend>
                          <b-form-input
                            id="i-name"
                            v-model="pixel.name"
                            :placeholder="$t('pixels.title')"
                            :state="errors.length > 0 ? false:null"
                            autocomplete="name"
                          />
                        </b-input-group>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>

                    <b-form-group>
                      <b-form-checkbox
                        v-model="all_pages"
                        value="1"
                      >
                        {{ $t('pixels.all_pages') }}
                      </b-form-checkbox>
                    </b-form-group>

                    <b-form-group
                      :label="$t('profile.notes')"
                      label-for="i-notes"
                    >
                      <b-input-group class="input-group-merge">
                        <b-input-group-prepend is-text>
                          <feather-icon icon="FileTextIcon" />
                        </b-input-group-prepend>
                        <b-form-textarea
                          id="i-notes"
                          v-model="pixel.notes"
                          :placeholder="$t('profile.notes')"
                        />
                      </b-input-group>
                    </b-form-group>

                    <b-form-group
                      label="Status"
                      label-for="i-status"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Status"
                        rules="required"
                      >
                        <v-select
                          id="i-status"
                          v-model="status"
                          placeholder="Choose the status"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :options="statuses"
                          label="text"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col
                    md="12"
                    class="d-flex align-items-center justify-content-end mt-1"
                  >
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="outline-secondary"
                      class="mr-0 mr-sm-1"
                      @click="$router.go(-1)"
                    >
                      <feather-icon
                        icon="ChevronLeftIcon"
                        class="mr-50"
                      />
                      <span class="align-middle">{{ $t('Back') }}</span>
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="primary"
                      @click="pixelUpdate"
                    >
                      <span class="align-middle">{{ $t('Save') }}</span>
                      <feather-icon
                        icon="ChevronRightIcon"
                        class="ml-50"
                      />
                    </b-button>
                  </b-col>
                </b-row>
              </b-card>
            </b-tab>
            <!--/ general tab -->
          </b-tabs>
        </validation-observer>
      </b-form>
    </div>
  </div>
</template>

<script>
import useJwt from '@/auth/jwt/useJwt'
import options from '@/libs/options'
import {
  BRow,
  BCol,
  BTabs,
  BTab,
  BCard,
  BForm,
  BFormGroup,
  // BInputGroupAppend,
  BInputGroupPrepend,
  BInputGroup,
  BFormInput,
  BFormCheckbox,
  BFormTextarea,
  BSpinner,
  VBTooltip,
  BButton,
} from 'bootstrap-vue'
import {
  ValidationProvider,
  ValidationObserver,
} from 'vee-validate'
import {
  required,
  integer,
  min,
} from '@validations'
import Breadcrumbs from '@/views/ui/breadcrumbs/Breadcrumbs.vue'
import { getUserData } from '@/auth/utils'
import UserToolbar from '@/views/dashboard/users/UserToolbar.vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BRow,
    BCol,
    BTabs,
    BTab,
    BCard,
    Breadcrumbs,
    BForm,
    BFormGroup,
    // BInputGroupAppend,
    BInputGroupPrepend,
    BInputGroup,
    BFormInput,
    BFormCheckbox,
    BFormTextarea,
    ValidationProvider,
    ValidationObserver,
    BSpinner,
    vSelect,
    BButton,
    UserToolbar,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {
      pageTitle: '',
      pageSubtitle: '',
      authUserData: getUserData(),
      account: {},
      min,
      required,
      integer,
      pixel: [],
      breadcrumbItems: [],
      status: {},
      all_pages: [],
      ...options,
    }
  },
  created() {
    this.getPixelData()
  },
  methods: {
    async getPixelData() {
      const responseData = await useJwt.getPixel(this.$route.params.id)
      this.pixel = Object.freeze(responseData.data.pixel) || []
      if (this.pixel.status !== '') {
        const statusText = this.pixel.status.charAt(0).toUpperCase() + this.pixel.status.slice(1)
        this.status = { value: this.pixel.status, text: statusText }
      }

      if (this.pixel.all_pages) {
        this.all_pages.push(1)
      } else {
        this.all_pages = null
      }
      this.getUserData()
    },
    pixelUpdate() {
      this.$refs.validationPixelRules.validate().then(success => {
        if (success) {
          this.pixel.status = this.status.value
          this.pixel.all_pages = this.all_pages
          useJwt.setPixel(this.$route.params.id, { pixel: this.pixel })
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Pixel saved',
              icon: 'EditIcon',
              variant: 'success',
            },
          })
        }
      })
    },
    async getUserData() {
      const responseData = await useJwt.getUser(this.$route.params.userId)
      this.account = responseData.data.account || {}
      this.pageTitle = this.account.name
      this.pageSubtitle = this.account.email
      this.setBreabcrumbs()
    },
    async setBreabcrumbs() {
      this.breadcrumbItems = [
        {
          text: 'Users',
          to: '/users',
        },
        {
          text: this.pageTitle,
          to: `/users/${this.$route.params.userId}`,
        },
        {
          text: 'Pixels',
          to: `/users/${this.$route.params.userId}/pixels`,
        },
        {
          text: await this.pixel.name,
          to: `/users/${this.$route.params.userId}/pixels/${this.$route.params.id}`,
        },
        {
          text: this.$t('Settings'),
          active: true,
        },
      ]
    },
  },
}
</script>
